import React from 'react'; 
import './comp.css';
import {Row, Col, Typography} from 'antd';


function About(){

    return (
        
        <div >
            <Row className="text" justify="center" >
                <Col span={16}>
                    <Typography>My name's Franklin.</Typography>
                    <br/>
                    <Typography>I'm currently a full time engineer at Apple based out of San Diego, California</Typography>
                    <br/>
                    <Typography>I graduated from Middlebury College in May 2022, where I earned my BA in Computer Science, with a minor in Studio Art</Typography>
                    <br/>
                    <Typography>I'm passionate about software development, content design, UX writing, and collaborating on meaningful and impactful projects</Typography>
                    <br/>
                    <Typography>I attribute a lot of my success to diversity & inclusion in the tech industry. 
                        A lot of what I've learned about being a Software Engineer is thanks to other latinos paying it forward, so that more people like us can find meaningful careers.
                        That being said I only intend to work at places where inclusivity is fostered and encouraged</Typography>
                    <br/>
                    <Typography>My hobbies include technology, music, and fixating on random recipes I find online</Typography>
                    <br/>
                    <Typography>Please feel free to reach out if your interested in chatting!</Typography>
                    <br/>
                </Col>
            </Row>
        </div>
    )
}

export default About; 